import { API, handleApiError } from "./utils";

export const getAlertVideoStream = async (id) => {
    try {
        const { data } = await API.get(`/alert/stream/${id}`, {
            responseType: 'blob' // Ensure response type is blob
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getAlert = async (id) => {
    try {
        const { data } = await API.get(`/alert/${id}`);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getAllAlerts = async () => {
    try {
        const { data } = await API.get("/alert");
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getArchAllAlerts = async (search, sortOrder, sortedColumn, cameras, alert_status, zones, treated, page, per_page, sites, categories, signal) => {
    try {
        const { data } = await API.get("/get_alerts/archived", {
            params: {
                search,
                sortOrder,
                sortedColumn,
                cameras,
                alert_status,
                zones,
                treated,
                page,
                per_page,
                sites,
                categories
            },
            signal: signal
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getLatestAlerts = async (site, company) => {
    try {
        console.log("Site and Company : ", site, company)
        const res = await API.get("/last_6_alerts", {
            params: {
                "site": site,
                "company": company
            },
        });
        return { error: null, data: res.data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getAlertsLast7DaysByHour = async (site, company, days, startDate, endDate) => {
    try {
        const { data } = await API.get("/alerts_last_7_days_by_hour", {
            params: { "site": site,
                "company": company,
                "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                "days": (startDate && endDate) ? undefined : (days || 7),
                "start_date": startDate || undefined,
                "end_date": endDate || undefined }
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getSiteById = async (siteId) => {
    try {
        const { data } = await API.get(`/sites/${siteId}`);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getZoneById = async (zoneId) => {
    try {
        const { data } = await API.get(`/zones/${zoneId}`);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getTotalAlerts = async (site, company) => {
    try {
        const { data } = await API.get("/total_alerts", { params: { 'site': site, 'company': company } });
        return { error: null, data };

    } catch (error) {
        return handleApiError(error);
    }
};
export const getTotalAlertsPerMonth = async (site, company) => {
    try {
        const { data } = await API.get("/alerts_this_month", { params: { 'site': site, 'company': company } });
        return { error: null, data };

    } catch (error) {
        return handleApiError(error);
    }
};

export const getIncidentsRate = async (site, company) => {
    try {
        const { data } = await API.get("/incident_rate", {
            params: {
                site: site,
                company: company
            },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getDashboardKpis = async (site, days = 30) => {
    try {
        const { data } = await API.get("/dashboard/kpis", {
            params: { site, days },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getHighestZonePerAlerts = async (site, company) => {
    try {
        const { data } = await API.get("/zone_with_most_alerts", {
            params: {
                "site": site,
                "company": company
            },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getAlertsWeekly = async (site, company) => {
    try {
        const { data } = await API.get("/alerts_weekly", { params: { "site": site, "company": company, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getAlertsDaily = async (site, company) => {
    try {
        const { data } = await API.get("/alerts_last_12_days", { params: { "site": site, "company": company, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getAlertsYearly = async (site, company) => {
    try {
        const { data } = await API.get("/alerts_yearly", { params: { "site": site, "company": company, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getAlertsMonthly = async (site, company) => {
    try {
        const { data } = await API.get("/alerts_monthly", { params: { "site": site, "company": company, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getCompilance = async (site, zone, company) => {
    try {
        const { data } = await API.get("/compilance", { params: { "site": site, "zone": zone, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getComparaisonAlertsToday = async (site, company) => {
    try {
        const { data } = await API.get("/comparaison_alerts_today", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getComparaisonAlertsWeek = async (site, company) => {
    try {
        const { data } = await API.get("/comparaison_alerts_alerts_this_week", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getComparaisonAlertsMonth = async (site, company) => {
    try {
        const { data } = await API.get("/comparasion_alerts_this_month", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getComparaisonAlertsTodayLastDay = async (site, company) => {
    try {
        const { data } = await API.get("/comparaison_alerts_today_yesterday", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getComparaisonAlertsThisWeekLastWeek = async (site, company) => {
    try {
        const { data } = await API.get("/comparaison_alerts_thisWeek_lastWeek", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getComparaisonAlertsThisMonthLastMonth = async (site, company) => {
    try {
        const { data } = await API.get("/comparaison_alerts_thisMonth_lastMonth", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getAlerts = async (search, sortOrder, sortedColumn, cameras, alert_status, zones, treated, page, per_page, sites, categories, signal, archived) => {
    try {
        const { data } = await API.get("/get_alerts", {
            params: {
                search,
                sortOrder,
                sortedColumn,
                cameras,
                alert_status,
                zones,
                treated,
                page,
                per_page,
                sites,
                categories,
                archived
            },
            signal: signal
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};
export const getLatestAlert = async (search) => {
    try {
        const { data } = await API.get("/get_latest_alert");
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getMostReportedIncident = async (site, company) => {
    try {
        const { data } = await API.get("/get_most_reported_incident", { params: { "site": site, "company": company } });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

// Full DB record (alert + model, site, zone, camera, rule, company) for each id -- used by the Alerts export.
export const getAlertExportDetails = async (ids) => {
    try {
        const { data } = await API.post("/alerts/export-details", { ids }, { skipSuccessToast: true });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const alertStatusUpdate = async (alert) => {
    try {
        const { data } = await API.put("/alerts/status/" + alert.Alert_ID,
            null, {
            params: {
                Note: alert.Note || "",
                alert_status: alert.alert_status,
                recordable: alert.recordable,
                alert_details: alert.alert_details || null,
            },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const alertDelete = async (id, options = {}) => {
    try {
        const { data } = await API.delete("/alerts/" + id, {
            skipSuccessToast: options.skipSuccessToast || false,
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const alertBulkDelete = async (ids, options = {}) => {
    try {
        const { data } = await API.post("/alerts/bulk-delete", { ids }, {
            skipSuccessToast: options.skipSuccessToast || false,
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const alertBulkArchive = async (ids, archived = true, options = {}) => {
    try {
        const { data } = await API.post("/alerts/bulk-archive", { ids, archived }, {
            skipSuccessToast: options.skipSuccessToast || false,
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

// Returns the zip as a Blob plus how many videos were included/skipped
// (alerts with no video file on disk are skipped server-side).
export const alertBulkDownloadVideos = async (ids) => {
    try {
        const response = await API.post("/alerts/bulk-download-videos", { ids }, {
            responseType: "blob",
            skipSuccessToast: true,
            timeout: 0,
        });
        return {
            error: null,
            data: response.data,
            included: Number(response.headers["x-videos-included"] || 0),
            skipped: Number(response.headers["x-videos-skipped"] || 0),
        };
    } catch (error) {
        // With responseType "blob" the JSON error body arrives as a Blob.
        const body = error?.response?.data;
        if (body instanceof Blob) {
            try {
                const detail = JSON.parse(await body.text())?.detail;
                if (detail) return { error: String(detail), data: null };
            } catch (_) { /* fall through to the generic handler */ }
        }
        return handleApiError(error);
    }
};

export const cleanupExpiredAlertVideos = async (options = {}) => {
    try {
        const { data } = await API.post("/alerts/cleanup-videos", null, {
            skipSuccessToast: options.skipSuccessToast || false,
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getRootCauseAnalysis = async (alertId) => {
    return getEventAnalysis(alertId);
};

export const getEventAnalysis = async (alertId) => {
    try {
        const { data } = await API.get(`/alerts/${alertId}/event-analysis`);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const generateRootCauseAnalysis = async (alertId, rerun = false) => {
    return generateEventAnalysis(alertId, rerun);
};

export const generateEventAnalysis = async (alertId, rerun = false) => {
    try {
        const { data } = await API.post(`/alerts/${alertId}/event-analysis`, null, {
            params: { rerun },
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getEventAnalysisStatus = async (alertId) => {
    try {
        const { data } = await API.get(`/alerts/${alertId}/event-analysis/status`);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const reviewEventAnalysis = async (alertId, version, review) => {
    try {
        const { data } = await API.post(`/alerts/${alertId}/event-analysis/${version}/review`, review);
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const downloadRootCauseAnalysisDocx = async (alertId) => {
    return downloadEventAnalysisDocx(alertId);
};

export const downloadEventAnalysisDocx = async (alertId) => {
    try {
        const { data } = await API.get(`/alerts/${alertId}/event-analysis.docx`, {
            responseType: "blob",
        });
        return { error: null, data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const getReport = async (site, filters = {}) => {
    try {
        const { data, error } = await API.get("/report/", {
            params: {
                site: site,
                start_date: filters.startDate || null,
                end_date: filters.endDate || null,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob'
        });
        return { error, data };
    } catch (error) {
        const responseBlob = error.response?.data;
        if (responseBlob instanceof Blob) {
            try {
                const text = await responseBlob.text();
                const parsed = JSON.parse(text);
                return {
                    error: parsed?.detail || parsed?.message || text || error.message,
                    data: null,
                };
            } catch {
                return { error: error.message, data: null };
            }
        }
        return handleApiError(error);
    }
};